import { updateGlobalCSSVars } from "manifest-components/src/Styles/globals";
import User from "manifest-components/src/classes/user";
import UserDetails from "manifest-components/src/classes/userDetails";
import { SlugValidation } from "manifest-components/src/classes/vendorConfig";
import { Actions, Action } from "./appActions";
import { AppState } from "./appState";

export default (state: typeof AppState, action: Action): typeof AppState => {
  switch (action.type) {
    case Actions.UPDATE_GLOBAL_CSS_VAR:
      // Don't trigger a change if they are the same value
      if (state.theme[action.payload.property] === action.payload.value) return state;
      updateGlobalCSSVars(action.payload.property, action.payload.value);
      return {
        ...state,
        theme: {
          ...state.theme,
          [action.payload.property]: action.payload.value,
        },
      };

    case Actions.SET_SHOW_HAMBURGER_MENU:
      return {
        ...state,
        showHamburgerMenu: !action.payload,
      };

    case Actions.SET_SHOW_TOP_BAR_ICONS:
      return {
        ...state,
        showTopBarIcons: action.payload,
      };

    case Actions.SET_SHOW_TOP_BAR_GRADIENT:
      return {
        ...state,
        showTopBarGradient: action.payload,
      };

    case Actions.GET_USER:
      return {
        ...state,
        user: action.payload,
        fetchingUser: false,
        userFetched: true,
      };

    case Actions.GET_USER_DETAILS: {
      return {
        ...state,
        userDetails: action.payload,
        userDetailsFetched: true,
        fetchingUserDetails: false,
      };
    }

    case Actions.CHANGE_EMAIL:
      return {
        ...state,
        emailAddressChanged: true,
      };

    case Actions.PASSWORD_CHANGED:
      return {
        ...state,
        passwordChanged: true,
      };

    case Actions.FETCHING_USER_DETAILS:
      return {
        ...state,
        fetchingUserDetails: true,
      };

    case Actions.FETCHING_USER:
      return {
        ...state,
        fetchingUser: true,
      };

    case Actions.FETCHING_EMPLOYER_DETAILS:
      return {
        ...state,
        employerDetailsFetched: false,
        fetchingEmployerDetails: true,
      };

    case Actions.GET_COUNTRIES:
      return {
        ...state,
        countriesList: action.payload,
        countriesListFetched: true,
      };

    case Actions.GET_SUFFIX:
      return {
        ...state,
        suffixList: action.payload,
        suffixListFetched: true,
      };

    case Actions.GET_STATES:
      return {
        ...state,
        statesList: action.payload,
        statesListFetched: true,
      };

    case Actions.SET_VENDOR_NAME:
      return {
        ...state,
        vendorName: action.payload,
      };

    case Actions.GET_EMPLOYER_CONFIGURATION:
      return {
        ...state,
        employerInfo: action.payload,
        employerInfoFetched: true,
      };

    case Actions.REMOVE_EMPLOYER_CONFIGURATION:
      return {
        ...state,
        employerInfo: {} as SlugValidation,
        employerInfoFetched: false,
      };

    case Actions.GET_EMPLOYER_DETAILS:
      return {
        ...state,
        employerDetails: action.payload,
        employerDetailsFetched: true,
      };

    case Actions.GET_VERIFICATION_CODE_DELIVERY_METHOD:
      return {
        ...state,
        verificationCodeDeliveryMethod: action.payload,
      };

    case Actions.CLEAR_USER_DETAILS_DATA:
      return {
        ...state,
        userFetched: false,
        fetchingEmployerDetails: false,
        employerDetailsFetched: false,
        userDetailsFetched: false,
        fetchingUser: false,
        user: {} as User,
        userDetails: {} as UserDetails,
        countriesList: [],
        countriesListFetched: false,
        suffixList: [],
        suffixListFetched: false,
        statesList: [],
        statesListFetched: false,
        verificationCodeDeliveryMethod: "",
      };

    case Actions.SET_NAVIGATION_BLOCKED:
      return {
        ...state,
        navigationBlockedReason: action.payload,
      };

    default:
      return state;
  }
};
